<template>
  <div>
    <WtDataTable
      ref="tables1"
      v-if="type == 1"
      key="detailtable1"
      :urlParams="{ project_id: id, if_pay: 3 }"
      :listUrl="$db.config.getProjectApplyList"
    >
      <template slot="columns">
        <el-table-column label="申请人" max-width="100" prop="user_name">
          <template slot-scope="scope">
            <a href="javascript:;" @click="goUserDetail(scope.row)">{{
              scope.row.user_name
            }}</a>
          </template>
        </el-table-column>

        <el-table-column
          label="申请项目"
          prop="project_name"
          max-width="250"
        ></el-table-column>

        <el-table-column
          label="申请时间"
          prop="regtime"
          max-width="100"
        ></el-table-column>

        <el-table-column
          label="救助状态"
          prop="audit_result_text"
          max-width="100"
        ></el-table-column>

        <el-table-column
          label="拨款状态"
          prop="status_text"
          max-width="100"
        ></el-table-column>

        <el-table-column label="操作" max-width="150">
          <template slot-scope="scope">
            <el-button-group>
              <template>
                <el-button
                  type="primary"
                  icon="el-icon-view"
                  style="padding: 5px 7px"
                  size="mini"
                  v-if="scope.row.pay_id > 0"
                  @click="showPayDetail(scope.row, 1)"
                  >拨款详情</el-button
                >
                <span v-else style="color: red">未申请拨款</span>
              </template>
            </el-button-group>
          </template>
        </el-table-column>
      </template>
    </WtDataTable>

    <WtDataTable
      ref="tables2"
      v-if="type == 2"
      key="detailtable2"
      :urlParams="{ project_id: id }"
      :listUrl="$db.config.getCfProjectAppropriation"
    >
      <div slot="buttons"></div>
      <template slot="columns">
        <el-table-column
          label="拨款申请时间"
          prop="reg_time"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          label="申请金额"
          prop="apply_money"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.apply_money | setNumFormat }}
          </template>
        </el-table-column>

        <!-- <el-table-column
                        label="总分配金额"
                        prop="top_money"
                        align="center"
                        min-width="150"
                      ></el-table-column> -->
        <el-table-column
          label="状态"
          prop="status_text"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span
              style="color: red; text-decoration: underline; cursor: pointer"
              v-if="scope.row.audit_opinion && scope.row.status == 2"
            >
              <el-popover
                placement="top"
                title="审核意见："
                width="200"
                trigger="click"
                :content="scope.row.audit_opinion"
              >
                <span slot="reference">{{ scope.row.status_text }}</span>
              </el-popover>
            </span>
            <span v-else>{{ scope.row.status_text }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="项目名称"
          align="center"
          prop="project_name"
          min-width="200"
        ></el-table-column>

        <el-table-column
          label="项目分类"
          prop="cat_name"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          label="总分配金额"
          prop="top_money"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          label="未拨款金额"
          prop="surplus_money"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          label="拨款状态"
          prop="status_text"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span
              style="color: red; text-decoration: underline; cursor: pointer"
              v-if="scope.row.found_opinion || scope.row.apply_status == 2"
            >
              <el-popover
                placement="top"
                title="审核意见："
                width="200"
                trigger="click"
                :content="scope.row.found_opinion"
              >
                <span slot="reference">{{ scope.row.apply_status_text }}</span>
              </el-popover>
            </span>
            <span v-else>{{ scope.row.apply_status_text }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="操作" max-width="150">
          <template slot-scope="scope">
            <el-button-group>
              <template>
                <el-button
                  type="primary"
                  icon="el-icon-view"
                  style="padding: 5px 7px"
                  v-if="Number(scope.row.apply_id) > 0"
                  size="mini"
                  @click="showPayDetail(scope.row, 2)"
                  >拨款详情</el-button
                >
                <span v-else style="color: red">未申请拨款</span>
              </template>
            </el-button-group>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="250" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button-group>
              <!-- <el-button
                type="primary"
                icon="el-icon-edit"
                v-if="scope.row.if_option"
                size="mini"
                @click="doPayment2(scope.row)"
                >编辑拨款</el-button
              > -->
              <el-button
                type="primary"
                icon="el-icon-view"
                size="mini"
                @click="showPayDetail(scope.row, 2)"
                >拨款信息</el-button
              >
            </el-button-group>
          </template>
        </el-table-column>
      </template>
    </WtDataTable>
    <pay-detail
      v-if="if_open"
      v-model="if_open"
      :pid="project_id"
      :id="apply_id"
      :type="type"
      :title="pay_title"
    ></pay-detail>
    <detail v-if="if_open1" v-model="if_open1" :id="apply_id"></detail>
  </div>
</template>
<script>
import payDetail from "../appropriation/detail";
import detail from "../apply/detail";
export default {
  components: {
    payDetail,
    detail,
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      if_open: false, //拨款详情、
      if_open1: false, //救助申请详情
      apply_id: null,
      project_id: null,
      pay_title: {
        user_name: null,
        pro_name: null,
      },

      paymentList: {},
    };
  },

  watch: {},
  methods: {
    //获取申请人详情
    goUserDetail(row) {
      this.apply_id = row.id;
      this.if_open1 = true;
    },

    //获取拨款申请详情
    showPayDetail(row, type) {
      if (type == 1) {
        this.project_id = row.project_id;
        this.apply_id = row.pay_id;
      } else {
        this.project_id = row.id;
        this.apply_id = row.apply_pay_id;
      }

      this.pay_title.pro_name = row.project_name;
      this.pay_title.user_name = row.user_name;
      this.if_open = true;
    },
  },
  created() {},
};
</script>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/detail_payment.vue